'use client'

import type { CmsPagePreviewProps } from '@maestro/sanity/components/cms/cms.types'

import { useLiveQuery } from '@sanity/preview-kit'
import { ReactNode, useEffect, useState } from 'react'

import { getCmsPage } from '@maestro/sanity/actions'

export default function CmsPagePreview({
  children,
  query,
  queryParams,
}: CmsPagePreviewProps) {
  const [page, setPage] = useState<ReactNode>(null)
  const [data] = useLiveQuery(null, query, queryParams)

  useEffect(() => {
    const fetchPageContent = async () => {
      // do not query backend on initial render
      if (!data) {
        return
      }
      const result = await getCmsPage(data)
      if (!ignore) {
        setPage(result)
      }
    }

    let ignore = false
    fetchPageContent()
    return () => {
      ignore = true
    }
  }, [data, setPage])

  return (
    <>
      <div className="cms-preview__indicator cms--full-width">
        <strong>Live preview mode</strong>
        {/* Full page load on purpose: a client-side navigation that redirects back to the current
            page (exit on "/") reuses the rendered page, so the preview would stay on screen */}
        {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
        <a href="/api/cms/exit-preview">Exit preview mode</a>
      </div>
      {!page && children}
      {page}
    </>
  )
}
